module.exports = __webpack_public_path__ + "img/nor_qt_moun1.eb4d05f7.png";